import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import uploadImageOnCloudinary from "../../components/uploads/uploadImg";
import { HttpClient } from "../../server/client/http";
import ClipLoader from "react-spinners/ClipLoader";



const UploadDocuments = () => {
    const [formData, setFormData] = useState({
        educationalCertificate: null,
        drivingLicense: null,
        skillCertificate: null,
        bankDetails: null,
    });

    // File preview states
    const [educationalCertificatePreview, setEducationalCertificatePreview] = useState(null);
    const [drivingLicensePreview, setDrivingLicensePreview] = useState(null);
    const [skillCertificatePreview, setSkillCertificatePreview] = useState(null);
    const [bankDetailsPreview, setBankDetailsPreview] = useState(null);
    const [isLoading, setIsLoading] = useState(false)

    const [loading, setLoading] = useState(false);

    // Handle image upload and update the state
    const getImageUrl = useCallback(async (e, type) => {
        setLoading(true);
        try {
            const url = await uploadImageOnCloudinary(e);
            console.log("Uploaded URL:", url);

            setFormData((prevState) => ({
                ...prevState,
                [type]: url, // Save the URL in the formData
            }));

            // Set preview for the uploaded image
            if (type === "educationalCertificate") setEducationalCertificatePreview(URL.createObjectURL(e.target.files[0]));
            if (type === "drivingLicense") setDrivingLicensePreview(URL.createObjectURL(e.target.files[0]));
            if (type === "skillCertificate") setSkillCertificatePreview(URL.createObjectURL(e.target.files[0]));
            if (type === "bankDetails") setBankDetailsPreview(URL.createObjectURL(e.target.files[0]));
        } catch (error) {
            console.error("Image upload failed:", error);
            alert("Failed to upload image. Please try again.");
        } finally {
            setLoading(false);
        }
    }, []);

    // Remove image
    const removeImage = (type) => {
        setFormData((prevState) => ({
            ...prevState,
            [type]: null,
        }));

        // Reset preview images
        if (type === "educationalCertificate") setEducationalCertificatePreview(null);
        if (type === "drivingLicense") setDrivingLicensePreview(null);
        if (type === "skillCertificate") setSkillCertificatePreview(null);
        if (type === "bankDetails") setBankDetailsPreview(null);
    };

    // Handle form submission
    const handleSave = async (e) => {
        console.log(formData)
        e.preventDefault();
        try {
            // Sending the form data as payload to the server
            const response = await HttpClient.put("/user/profile/uploads", formData);
            console.log(response);
            getUploadedData()

        } catch (error) {
            console.error("Error uploading documents:", error);
            // Handle error
            alert("Failed to upload documents. Please try again.");
        }
    };


    const getUploadedData = async () => {
        setIsLoading(true)
        try {
            const response = await HttpClient.get("/user/profile/uploads");
             setIsLoading(false)
            if (response.success) {
                const { educationalCertificate, drivingLicense, skillCertificate, bankDetails } = response.data;

                // Set the formData with fetched data
              
                 setFormData({
                    educationalCertificate: educationalCertificate?educationalCertificate : null,
                    drivingLicense: drivingLicense?drivingLicense : null,
                    skillCertificate: drivingLicense?skillCertificate : null,
                    bankDetails: bankDetails?bankDetails : null,
                });

                // Set previews for fetched data
                setEducationalCertificatePreview(educationalCertificate?educationalCertificate:null);
                setDrivingLicensePreview(drivingLicense?drivingLicense:null);
                setSkillCertificatePreview(skillCertificate?skillCertificate : null);
                setBankDetailsPreview(bankDetails?skillCertificate : null);
               }
               
            }
           
         catch (err) {
            console.error("Error fetching uploaded data:", err);
        }
    };



    useEffect(() => {
        getUploadedData();
    }, [])

    return (
        <div className="flex flex-col items-center min-h-screen bg-gray-100 py-10 p-2 md:p-10">
            {
                isLoading ? <div className="flex justify-center items-center h-screen">
                    <ClipLoader size={50} color="#4ade80" />

                </div> : <form className="w-full bg-white shadow-lg rounded-lg p-8" onSubmit={handleSave}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Educational Certificate */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">Educational Certificate</label>
                            <input
                                type="file"
                                accept="image/*,application/pdf,text/plain"
                                className="w-full border border-gray-300 rounded-lg p-3"
                                onChange={(e) => getImageUrl(e, "educationalCertificate")}
                            />
                            {educationalCertificatePreview && (
                                <div className="relative w-32 h-32 mt-4">
                                    <img
                                        src={educationalCertificatePreview}
                                        alt="Educational Certificate Preview"
                                        className="object-cover border rounded-lg w-full h-full"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => removeImage("educationalCertificate")}
                                        className="absolute top-0 right-0 bg-[#c5363c] text-white rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-[#c5363c]"
                                    >
                                        &times;
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Skill Certificate */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">Skill Certificate</label>
                            <input
                                type="file"
                                accept="image/*,application/pdf,text/plain"
                                className="w-full border border-gray-300 rounded-lg p-3"
                                onChange={(e) => getImageUrl(e, "skillCertificate")}
                            />
                            {skillCertificatePreview && (
                                <div className="relative w-32 h-32 mt-4">
                                    <img
                                        src={skillCertificatePreview}
                                        alt="Skill Certificate Preview"
                                        className="object-cover border rounded-lg w-full h-full"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => removeImage("skillCertificate")}
                                        className="absolute top-0 right-0 bg-[#c5363c] text-white rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-[#c5363c]"
                                    >
                                        &times;
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                        {/* Upload Passport / Driving License */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">Driving License</label>
                            <input
                                type="file"
                                accept="image/*,application/pdf,text/plain"
                                className="w-full border border-gray-300 rounded-lg p-3"
                                onChange={(e) => getImageUrl(e, "drivingLicense")}
                            />
                            {drivingLicensePreview && (
                                <div className="relative w-32 h-32 mt-4">
                                    <img
                                        src={drivingLicensePreview}
                                        alt="Driving License Preview"
                                        className="object-cover border rounded-lg w-full h-full"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => removeImage("drivingLicense")}
                                        className="absolute top-0 right-0 bg-[#c5363c] text-white rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-[#c5363c]"
                                    >
                                        &times;
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Upload Bank Details */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">Bank Details</label>
                            <input
                                type="file"
                                accept="image/*,application/pdf,text/plain"
                                className="w-full border border-gray-300 rounded-lg p-3"
                                onChange={(e) => getImageUrl(e, "bankDetails")}
                            />
                            {bankDetailsPreview && (
                                <div className="relative w-32 h-32 mt-4">
                                    <img
                                        src={bankDetailsPreview}
                                        alt="Bank Details Preview"
                                        className="object-cover border rounded-lg w-full h-full"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => removeImage("bankDetails")}
                                        className="absolute top-0 right-0 bg-[#c5363c] text-white rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-[#c5363c]"
                                    >
                                        &times;
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="flex flex-col md:flex-row justify-center mt-8 gap-4">
                        <button
                            type="submit"
                            className="py-1 px-6 bg-[#c5363c] text-white rounded-lg hover:bg-[#c5363c] w-full md:w-auto"
                        >
                            Update Images
                        </button>
                    </div>
                </form>
            }


        </div>
    );
};

export default UploadDocuments;
